export const START_TIMER = 'START_TIMER'
export const DECREMENT_COUNTER = 'DECREMENT_COUNTER'
export const RESET_INTERVAL_ID = 'RESET_INTERVAL_ID'
export const RESET_COUNTER_REDUX = 'RESET_COUNTER_REDUX'
export const ADD_NEW_ROUND = 'ADD_NEW_ROUND'
export const SET_END_TIME = 'SET_END_TIME'
export const INCREMENT_RINGCOUNT = 'INCREMENT_RINGCOUNT'
export const SET_COUNTER = 'SET_COUNTER'

export const startTimer = (id, name, seconds, type) => dispatch =>
  dispatch({
    type: START_TIMER,
    payload: { id, name, seconds, type },
  })

export const decrementCounter = () => ({
  type: DECREMENT_COUNTER,
})

export const resetIntervalId = () => ({
  type: RESET_INTERVAL_ID,
})

export const resetCounterRedux = () => ({
  type: RESET_COUNTER_REDUX,
})

export const addNewRoundOnTimer = (id, seconds) => dispatch =>
  dispatch({
    type: ADD_NEW_ROUND,
    payload: {
      id,
      seconds,
    },
  })

export const setCounter = counter => ({
  type: SET_COUNTER,
  payload: counter,
})



// WEBPACK FOOTER //
// ./src/modules/counter/actions.js